new ScrollReveal().reveal('.nostot .nosto-column', {
    delay: 0,
    duration: 1000,
    distance: '150px',
    reset: false
});

new ScrollReveal().reveal('.nostolaatikot', {
    delay: 0,
    duration: 1000,
    distance: '150px',
    reset: false,
});


new ScrollReveal().reveal('.ikoninostot .nosto-column', {
    delay: 0,
    duration: 1000,
    distance: '150px',
    reset: false
});


new ScrollReveal().reveal('.numeronostot .numeronosto', {
    delay: 0,
    duration: 1000,
    distance: '150px',
    reset: false,
});

new ScrollReveal().reveal('.wp-block-acf-background.is-first-block .background .background__content', {
    delay: 0,
    duration: 1000,
    distance: '150px',
    reset: false
});


new ScrollReveal().reveal('.wp-block-acf-media-text .media-text .media-text__content .media-text__content__inner', {
    delay: 0,
    duration: 1000,
    distance: '150px',
    reset: false
});
